export class Repeater {
	timeout: number = 30000;
	
	errorTimeout: number = 0;
	
	timer: any;
	
	cb: Function;
	
	constructor(cb, timeout) {
		this.cb = cb;
		this.timeout = timeout;
	}
	
	
	start() {
		let me = this;
		
		me.stop();
		
		me.timer = setTimeout(async () => {
			try {
				await me.cb();

				me.errorTimeout = 0;
			} catch(err) {
				console.error(err);

				if (me.errorTimeout === 0) {
					me.errorTimeout = me.timeout;
				}

				me.errorTimeout = me.errorTimeout * 2;
			}
			
			me.start();
		}, me.errorTimeout || me.timeout);
	}
	
	
	stop() {
		if (this.timer) {
			clearTimeout(this.timer);
		}
	}
}
